// Fire-and-forget notification for action create/reassign (#472, g11).
//
// Mirrors the fireNotify() pattern in pages/qa/[id].tsx: a best-effort POST
// to an edge function that itself degrades gracefully (RESEND_API_KEY unset,
// unassigned owner, etc. all return {sent:false, reason} rather than
// throwing). Errors here are swallowed — a failed notification must never
// block the create/reassign flow the caller already completed successfully.

import { supabase } from "@/lib/supabase";

const NOTIFY_EF_URL =
  import.meta.env.VITE_ACTIONS_ASSIGNMENT_NOTIFY_URL ||
  `${import.meta.env.VITE_SUPABASE_URL ?? ""}/functions/v1/actions-assignment-notify`;

export type ActionAssignmentEvent = "created" | "reassigned";

export async function notifyActionAssignment(
  code: string,
  event: ActionAssignmentEvent,
): Promise<void> {
  try {
    const { data: { session } } = await supabase.auth.getSession();
    const headers: Record<string, string> = { "Content-Type": "application/json" };
    if (session?.access_token) headers["Authorization"] = `Bearer ${session.access_token}`;
    await fetch(NOTIFY_EF_URL, {
      method: "POST",
      headers,
      body: JSON.stringify({ code, event }),
    });
  } catch {
    // Best-effort only — the create/reassign itself already succeeded.
  }
}
